import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-main">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              精选护理文章
            </h2>
            <p className="text-sm text-foreground-600">最受欢迎的被芯护理知识和技巧</p>
          </div>
          <Link
            to="/category/beixin"
            className="hidden md:flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors no-underline whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 no-underline cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors font-heading">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>{article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>{article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category/beixin"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors no-underline"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}